import Referee from "@/models/referee";
import User from "@/models/user";
import Service from "@/models/service";
import Company from "@/models/company";

export default class RefereeUser extends Referee {

    constructor(options) {
        super(options);
        this.user = new User(options?.user)
        this.company = new Company(options?.company)
        this.service = new Service(options?.service)
    }

    toData() {
        let referee = super.toData();
        referee.user = this.user.toData()
        referee.company = this.company.toData()
        referee.service = this.service.toData()
        return referee
    }

    toJSON () {
        return { ...this }
    }
}
